import { z } from 'zod';
import { DefinitionStatusSchema } from './schema';
export const ZoneValidationSchema = z.object({
    isInheritable: z.boolean().optional(),
    moduleRestrictions: z
        .array(z.object({
        name: z.string(),
        version: z.string()
    }))
        .optional()
});
export const ZoneDefinitionSchema = z.object({
    name: z.string(),
    label: z.string(),
    description: z.string(),
    status: DefinitionStatusSchema,
    validations: ZoneValidationSchema.optional()
});
//# sourceMappingURL=zone-definition.js.map